var map = {
	"./1.png": "6561",
	"./10.png": "3e57",
	"./11.png": "88f7",
	"./2.png": "b576",
	"./3.png": "387a",
	"./4.png": "7301",
	"./5.png": "dcb9",
	"./6.png": "2806",
	"./7.png": "7664",
	"./8.png": "678d",
	"./9.png": "b24d",
	"./LOGO1.png": "ef41",
	"./LOGO2.png": "7f4e",
	"./ad.png": "5a1c",
	"./background.png": "9c1e",
	"./cqzy.png": "1206",
	"./csmz.png": "8715",
	"./gdqg.png": "a11d",
	"./hnqc.png": "d9e8",
	"./jxhj.png": "9f9f",
	"./redbg-title.png": "dac6",
	"./resource_banner_mobile.png": "49aa",
	"./szxxzy.png": "e0af",
	"./szzy.png": "10db6",
	"./whitebg-title.png": "c0b3",
	"./whzy.png": "afdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "078f";